var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Article = (function (Article) {

        Article.Messages = (function (Messages) {

            Messages.ReviewSubmit = function (reviewArticleId, reviewTitle, reviewDescription, reviewRating) {
            var data = {
                ReviewArticleId: reviewArticleId,
                ReviewTitle: reviewTitle,
                ReviewDescription: reviewDescription,
                ReviewRating: reviewRating
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Article.Messages.ReviewSubmit', data);
        };
        Messages.ReviewSubmit.className = 'Vendd.Article.Messages.ReviewSubmit';

        Messages.ReviewSuccess = function (response) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Article.Messages.ReviewSuccess', response);
        };
        Messages.ReviewSuccess.className = 'Vendd.Article.Messages.ReviewSuccess';

        Messages.ReviewFailure = function (response) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Article.Messages.ReviewFailure', response);
        };
        Messages.ReviewFailure.className = 'Vendd.Article.Messages.ReviewFailure';

        Messages.ReviewVote = function (id, positive) {
            var data = {
                helpfullness: {
                    Id: id,
                    IsPositiveVote: positive
                }
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Article.Messages.ReviewVote', data);
        };
        Messages.ReviewVote.className = 'Vendd.Article.Messages.ReviewVote';

        Messages.ReviewVoteSuccess = function (response, vote) {
            response.data = JSON.parse(response.data);

            var data = {
                response: response,
                vote: vote
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Article.Messages.ReviewVoteSuccess', data);
        };
        Messages.ReviewVoteSuccess.className = 'Vendd.Article.Messages.ReviewVoteSuccess';

        Messages.ReviewVoteFailure = function (response, vote) {
            response.data = JSON.parse(response.data);

            var data = {
                response: response,
                vote: vote
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Article.Messages.ReviewVoteFailure', data);
        };
        Messages.ReviewVoteFailure.className = 'Vendd.Article.Messages.ReviewVoteFailure';

        return Messages;

    })(Article.Messages || {});

        return Article;

    })(Vendd.Article || {});

return Vendd;

})(Vendd || {});